
    import { defineComponent } from "vue"

    export default defineComponent({
        props: {
            value: {
                type: Boolean,
                default: () => false
            },

        },
        components: {

        },
        data() {
            return {

            }
        },
        computed: {

        },
        methods: {

        },
    })

    